import { compose } from 'redux';
import gql from 'graphql-tag';
import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import { reduxForm, formValueSelector } from 'redux-form';
import OrderPaymentForm from './OrderPaymentForm';

const installments = gql`
  query installments($eventId: String, $total: Float!, $foreign: Boolean) {
    installments(eventId: $eventId, total: $total, foreign: $foreign) {
      installmentCount
      installmentValue
      interest
      grandTotalValue
    }
  }
`;

const paymentFormSelector = formValueSelector('order');
function mapStateToProps(state) {
  return {
    paymentForm: paymentFormSelector(state, 'paymentForm'),
    installmentsCount: paymentFormSelector(state, 'installmentsCount'),
    foreignBuyer: paymentFormSelector(state, 'buyer.foreign'),
    cardNumber: paymentFormSelector(state, 'creditCard.number'),
    ccv: paymentFormSelector(state, 'creditCard.ccv'),
  };
}

export default compose(
  reduxForm({
    form: 'order',
    destroyOnUnmount: false,
  }),
  connect(mapStateToProps),
  graphql(installments, {
    name: 'installmentsData',
    skip: props => !props.event.registerPaymentForms.creditCard.installmentEnabled,
    options: props => ({
      variables: {
        eventId: props.event.id,
        total: props.preOrder.totalValue,
        foreign: props.foreignBuyer,
      },
    }),
  }),
)(OrderPaymentForm);



// WEBPACK FOOTER //
// ./src/site-render/src/RegisterExtension/OrderPaymentForm/OrderPaymentFormContainer.js